import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/widget';

// Constants

// Thunks

export const getCompanyByClientId = createAsyncThunk(
  'widget/getCompanyByClientId',
  async ({ clientId }, { rejectWithValue }) => {
    try {
      const data = await api.getCompanyByClientId(clientId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getCompanyByCode = createAsyncThunk(
  'widget/getCompanyByCode',
  async ({ companyCode }, { rejectWithValue }) => {
    try {
      const data = await api.getCompanyByCode(companyCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getGuestById = createAsyncThunk(
  'widget/getGuestById',
  async ({ guestId }, { rejectWithValue }) => {
    try {
      const data = await api.getGuestById(guestId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getGuestByReservationId = createAsyncThunk(
  'widget/getGuestByReservationId',
  async ({ reservationId }, { rejectWithValue }) => {
    try {
      const data = await api.getGuestByReservationId(reservationId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getGuestByReservation = createAsyncThunk(
  'widget/getGuestByReservation',
  async ({ companyCode, reservationCode }, { rejectWithValue }) => {
    try {
      const data = await api.getGuestByReservation(companyCode, reservationCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getGuestByUniqueAttributes = createAsyncThunk(
  'widget/getGuestByUniqueAttributes',
  async ({
    firstName, lastName, phoneNumber, postalCode,
  }, { rejectWithValue }) => {
    try {
      const data = await api.getGuestByUniqueAttributes(firstName, lastName, phoneNumber, postalCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getReservationById = createAsyncThunk(
  'widget/getReservationById',
  async ({ reservationId }, { rejectWithValue }) => {
    try {
      const data = await api.getReservationById(reservationId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getReservationByCode = createAsyncThunk(
  'widget/getReservationByCode',
  async ({ companyCode, reservationCode }, { rejectWithValue }) => {
    try {
      const data = await api.getReservationByCode(companyCode, reservationCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getReservationsByCompanyCode = createAsyncThunk(
  'widget/getReservationsByCompanyCode',
  async ({ companyCode }, { rejectWithValue }) => {
    try {
      const data = await api.getReservationsByCompanyCode(companyCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getSummaryByCompanyCode = createAsyncThunk(
  'widget/getSummaryByCompanyCode',
  async ({ companyCode }, { rejectWithValue }) => {
    try {
      const data = await api.getSummaryByCompanyCode(companyCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getSessionByGuestId = createAsyncThunk(
  'widget/getSessionByGuestId',
  async ({ guestId }, { rejectWithValue }) => {
    try {
      const data = await api.getSessionByGuestId(guestId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getSessionByReservation = createAsyncThunk(
  'widget/getSessionByReservation',
  async ({ companyCode, reservationCode }, { rejectWithValue }) => {
    try {
      const data = await api.getSessionByReservation(companyCode, reservationCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getSessionByReference = createAsyncThunk(
  'widget/getSessionByReference',
  async ({ reference }, { rejectWithValue }) => {
    try {
      const data = await api.getSessionByReference(reference);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createVerificationSession = createAsyncThunk(
  'widget/createVerificationSession',
  async ({ companyCode, reservationCode }, { rejectWithValue }) => {
    try {
      const data = await api.createVerificationSession(companyCode, reservationCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getPaymentCardImageByReference = createAsyncThunk(
  'widget/getPaymentCardImageByReference',
  async ({ reference }, { rejectWithValue }) => {
    try {
      const data = await api.getPaymentCardImageByReference(reference);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getPaymentCardBackupByReference = createAsyncThunk(
  'widget/getPaymentCardBackupByReference',
  async ({ reference }, { rejectWithValue }) => {
    try {
      const data = await api.getPaymentCardBackupByReference(reference);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getPaymentCardSessionByReference = createAsyncThunk(
  'widget/getPaymentCardSessionByReference',
  async ({ reference }, { rejectWithValue }) => {
    try {
      const data = await api.getPaymentCardSessionByReference(reference);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getPaymentCardSessionByIdentityReference = createAsyncThunk(
  'widget/getPaymentCardSessionByIdentityReference',
  async ({ reference }, { rejectWithValue }) => {
    try {
      const data = await api.getPaymentCardSessionByIdentityReference(reference);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getPaymentCardSessionByReservation = createAsyncThunk(
  'widget/getPaymentCardSessionByReservation',
  async ({ companyCode, reservationCode }, { rejectWithValue }) => {
    try {
      const data = await api.getPaymentCardSessionByReservation(companyCode, reservationCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createPaymentCardSession = createAsyncThunk(
  'widget/createPaymentCardSession',
  async ({ companyCode, reservationCode }, { rejectWithValue }) => {
    try {
      const data = await api.createPaymentCardSession(companyCode, reservationCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const patchPaymentCardSession = createAsyncThunk(
  'widget/patchPaymentCardSession',
  async (card, { rejectWithValue }) => {
    try {
      const data = await api.patchPaymentCardSession(card);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const parsePaymentCard = createAsyncThunk(
  'widget/parsePaymentCard',
  async ({ companyCode, reservationCode, cardImage }, { rejectWithValue }) => {
    try {
      const data = await api.parsePaymentCard(companyCode, reservationCode, cardImage);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const saveEditedPaymentCard = createAsyncThunk(
  'widget/saveEditedPaymentCard',
  async ({ reference, cardImage }, { rejectWithValue }) => {
    try {
      const data = await api.saveEditedPaymentCard(reference, cardImage);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getPaymentCardSessionsByStatus = createAsyncThunk(
  'widget/getPaymentCardSessionsByStatus',
  async ({ statusCode }, { rejectWithValue }) => {
    try {
      const data = await api.getPaymentCardSessionsByStatus(statusCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getNameAddressMatchByGuestId = createAsyncThunk(
  'widget/getNameAddressMatchByGuestId',
  async ({ guestId }, { rejectWithValue }) => {
    try {
      const data = await api.getNameAddressMatchByGuestId(guestId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getRiskVerificationByGuestId = createAsyncThunk(
  'widget/getRiskVerificationByGuestId',
  async ({ guestId }, { rejectWithValue }) => {
    try {
      const data = await api.getRiskVerificationByGuestId(guestId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getBackgroundCheckByGuestId = createAsyncThunk(
  'widget/getBackgroundCheckByGuestId',
  async ({ guestId }, { rejectWithValue }) => {
    try {
      const data = await api.getBackgroundCheckByGuestId(guestId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getReviewById = createAsyncThunk(
  'widget/getReviewById',
  async ({ reviewId }, { rejectWithValue }) => {
    try {
      const data = await api.getReviewById(reviewId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const validateReviewByGuestId = createAsyncThunk(
  'widget/validateReviewByGuestId',
  async ({ reviewId, guestId }, { rejectWithValue }) => {
    try {
      const data = await api.validateReviewByGuestId(reviewId, guestId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getReviewList = createAsyncThunk(
  'widget/getReviewList',
  async ({ guestId }, { rejectWithValue }) => {
    try {
      const data = await api.getReviewList(guestId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getReviewSummary = createAsyncThunk(
  'widget/getReviewSummary',
  async ({ guestId }, { rejectWithValue }) => {
    try {
      const data = await api.getReviewSummary(guestId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getVerificationList = createAsyncThunk(
  'widget/getVerificationList',
  async ({ companyCode }, { rejectWithValue }) => {
    try {
      const data = await api.getVerificationList(companyCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getRecentVerifications = createAsyncThunk(
  'widget/getRecentVerifications',
  async ({ companyCode }, { rejectWithValue }) => {
    try {
      const data = await api.getRecentVerifications(companyCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getReservationByReference = createAsyncThunk(
  'widget/getReservationByReference',
  async ({ reference }, { rejectWithValue }) => {
    try {
      const data = await api.getReservationByReference(reference);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createNameAddressMatch = createAsyncThunk(
  'widget/createNameAddressMatch',
  async ({ companyCode, reservationCode }, { rejectWithValue }) => {
    try {
      const data = await api.createNameAddressMatch(companyCode, reservationCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createRiskVerificationSession = createAsyncThunk(
  'widget/createRiskVerificationSession',
  async ({ companyCode, reservationCode }, { rejectWithValue }) => {
    try {
      const data = await api.createRiskVerificationSession(companyCode, reservationCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createBackgroundCheckSession = createAsyncThunk(
  'widget/createBackgroundCheckSession',
  async ({ companyCode, reservationCode }, { rejectWithValue }) => {
    try {
      const data = await api.createBackgroundCheckSession(companyCode, reservationCode);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const addGuest = createAsyncThunk(
  'widget/addGuest',
  async (guest, { rejectWithValue }) => {
    try {
      const data = await api.addGuest(guest);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateGuest = createAsyncThunk(
  'widget/updateGuest',
  async ({ guestId, guestData }, { rejectWithValue }) => {
    try {
      const data = await api.updateGuest(guestId, guestData);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const addReservation = createAsyncThunk(
  'widget/addReservation',
  async (reservation, { rejectWithValue }) => {
    try {
      const data = await api.addReservation(reservation);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateReservation = createAsyncThunk(
  'widget/updateReservation',
  async ({ reservationId, reservationData }, { rejectWithValue }) => {
    try {
      const data = await api.updateReservation(reservationId, reservationData);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const addReview = createAsyncThunk(
  'widget/addReview',
  async (review, { rejectWithValue }) => {
    try {
      const data = await api.addReview(review);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateReview = createAsyncThunk(
  'widget/updateReview',
  async ({ reviewId, reviewData }, { rejectWithValue }) => {
    try {
      const data = await api.updateReview(reviewId, reviewData);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Initial state

const initialState = {
  company: null,
  companyCode: null,
  reservationCode: null,
  guest: null,
  reservation: null,
  review: null,
  reviewList: [],
  reviewSummary: null,
  identity: null,
  address: null,
  card: null,
  risk: null,
  background: null,
  cardList: null,
  verificationList: [],
  recentVerifications: [],
  verificationSummary: {},
  isPending: false,
  hasGuestAccess: false,
  disableWriteReview: false,
  disableIdentityVerification: false,
};

// Slice

export const widgetSlice = createSlice({
  name: 'widget',
  initialState,
  reducers: {
    resetWidget(state) {
      Object.assign(state, initialState);
    },
    setDisableWriteReview(state, action) {
      state.disableWriteReview = !!action.payload;
    },
    setDisableIdentityVerification(state, action) {
      state.disableIdentityVerification = !!action.payload;
    },
    setCompanyCode(state, action) {
      state.companyCode = action.payload;
    },
    setReservationCode(state, action) {
      state.reservationCode = action.payload;
    },
    setReservationData(state, action) {
      const { reservationCode, companyCode } = action.payload;
      state.reservationCode = reservationCode;
      state.companyCode = companyCode;
    },
    updateCardInList(state, action) {
      const { card } = action.payload;
      state.cardList = state.cardList.map((c) => ((c.id === card.id) ? card : c));
    },
    removeCardFromList(state, action) {
      const { card } = action.payload;
      state.cardList = state.cardList.filter((c) => (c.id !== card.id));
    },
  },
  extraReducers: {
    [getCompanyByClientId.rejected]: (state) => {
      state.isPending = false;
    },
    [getCompanyByClientId.pending]: (state) => {
      state.isPending = true;
    },
    [getCompanyByClientId.fulfilled]: (state, action) => {
      state.company = action.payload;
      state.isPending = false;
    },
    [getCompanyByCode.rejected]: (state) => {
      state.isPending = false;
    },
    [getCompanyByCode.pending]: (state) => {
      state.isPending = true;
    },
    [getCompanyByCode.fulfilled]: (state, action) => {
      state.company = action.payload;
      state.isPending = false;
    },
    [getGuestById.rejected]: (state) => {
      state.isPending = false;
    },
    [getGuestById.pending]: (state) => {
      state.isPending = true;
    },
    [getGuestById.fulfilled]: (state, action) => {
      state.guest = action.payload;
      state.isPending = false;
    },
    [getGuestByReservationId.rejected]: (state) => {
      state.isPending = false;
    },
    [getGuestByReservationId.pending]: (state) => {
      state.isPending = true;
    },
    [getGuestByReservationId.fulfilled]: (state, action) => {
      state.guest = action.payload;
      state.isPending = false;
    },
    [getGuestByReservation.rejected]: (state) => {
      state.isPending = false;
    },
    [getGuestByReservation.pending]: (state) => {
      state.isPending = true;
    },
    [getGuestByReservation.fulfilled]: (state, action) => {
      state.guest = action.payload;
      state.isPending = false;
    },
    [getGuestByUniqueAttributes.rejected]: (state) => {
      state.isPending = false;
    },
    [getGuestByUniqueAttributes.pending]: (state) => {
      state.isPending = true;
    },
    [getGuestByUniqueAttributes.fulfilled]: (state, action) => {
      state.guest = action.payload;
      state.isPending = false;
    },
    [getReservationById.rejected]: (state) => {
      state.isPending = false;
    },
    [getReservationById.pending]: (state) => {
      state.isPending = true;
    },
    [getReservationById.fulfilled]: (state, action) => {
      state.reservation = action.payload;
      state.isPending = false;
    },
    [getReservationByCode.rejected]: (state) => {
      state.isPending = false;
    },
    [getReservationByCode.pending]: (state) => {
      state.isPending = true;
    },
    [getReservationByCode.fulfilled]: (state, action) => {
      state.reservation = action.payload;
      state.isPending = false;
    },
    [getReservationsByCompanyCode.rejected]: (state) => {
      state.isPending = false;
    },
    [getReservationsByCompanyCode.pending]: (state) => {
      state.isPending = true;
    },
    [getReservationsByCompanyCode.fulfilled]: (state) => {
      state.isPending = false;
    },
    [getReservationByReference.rejected]: (state) => {
      state.isPending = false;
    },
    [getReservationByReference.pending]: (state) => {
      state.isPending = true;
    },
    [getReservationByReference.fulfilled]: (state, action) => {
      const { companyCode, reservationCode } = action.payload;
      state.companyCode = companyCode;
      state.reservationCode = reservationCode;
      state.isPending = false;
    },
    [getSessionByGuestId.rejected]: (state) => {
      state.identity = null;
      state.isPending = false;
    },
    [getSessionByGuestId.pending]: (state) => {
      state.isPending = true;
    },
    [getSessionByGuestId.fulfilled]: (state, action) => {
      state.identity = action.payload;
      state.isPending = false;
    },
    [getSessionByReservation.rejected]: (state) => {
      state.identity = null;
      state.isPending = false;
    },
    [getSessionByReservation.pending]: (state) => {
      state.isPending = true;
    },
    [getSessionByReservation.fulfilled]: (state, action) => {
      state.identity = action.payload;
      state.isPending = false;
    },
    [getSessionByReference.rejected]: (state) => {
      state.identity = null;
      state.isPending = false;
    },
    [getSessionByReference.pending]: (state) => {
      state.isPending = true;
    },
    [getSessionByReference.fulfilled]: (state, action) => {
      state.identity = action.payload;
      state.isPending = false;
    },
    [getReviewById.rejected]: (state) => {
      state.isPending = false;
    },
    [getReviewById.pending]: (state) => {
      state.isPending = true;
    },
    [getReviewById.fulfilled]: (state, action) => {
      state.review = action.payload;
      state.isPending = false;
    },
    [validateReviewByGuestId.rejected]: (state) => {
      state.isPending = false;
    },
    [validateReviewByGuestId.pending]: (state) => {
      state.isPending = true;
    },
    [validateReviewByGuestId.fulfilled]: (state, action) => {
      state.hasGuestAccess = action.payload;
      state.isPending = false;
    },
    [getReviewList.rejected]: (state) => {
      state.isPending = false;
    },
    [getReviewList.pending]: (state) => {
      state.isPending = true;
    },
    [getReviewList.fulfilled]: (state, action) => {
      state.reviewList = action.payload;
      state.isPending = false;
    },
    [getReviewSummary.rejected]: (state) => {
      state.isPending = false;
    },
    [getReviewSummary.pending]: (state) => {
      state.isPending = true;
    },
    [getReviewSummary.fulfilled]: (state, action) => {
      state.reviewSummary = action.payload;
      state.isPending = false;
    },
    [getVerificationList.rejected]: (state) => {
      state.isPending = false;
    },
    [getVerificationList.pending]: (state) => {
      state.isPending = true;
    },
    [getVerificationList.fulfilled]: (state, action) => {
      state.verificationList = action.payload;
      state.isPending = false;
    },
    [getRecentVerifications.rejected]: (state) => {
      state.recentVerifications = [];
      state.isPending = false;
    },
    [getRecentVerifications.pending]: (state) => {
      state.isPending = true;
    },
    [getRecentVerifications.fulfilled]: (state, action) => {
      state.recentVerifications = action.payload;
      state.isPending = false;
    },
    [getSummaryByCompanyCode.rejected]: (state) => {
      state.verificationSummary = {};
      state.isPending = false;
    },
    [getSummaryByCompanyCode.pending]: (state) => {
      state.isPending = true;
    },
    [getSummaryByCompanyCode.fulfilled]: (state, action) => {
      state.verificationSummary = action.payload;
      state.isPending = false;
    },
    [createVerificationSession.rejected]: (state) => {
      state.isPending = false;
    },
    [createVerificationSession.pending]: (state) => {
      state.isPending = true;
    },
    [createVerificationSession.fulfilled]: (state, action) => {
      state.identity = action.payload;
      state.isPending = false;
    },
    [getPaymentCardImageByReference.rejected]: (state) => {
      state.isPending = false;
    },
    [getPaymentCardImageByReference.pending]: (state) => {
      state.isPending = true;
    },
    [getPaymentCardImageByReference.fulfilled]: (state) => {
      state.isPending = false;
    },
    [getPaymentCardBackupByReference.rejected]: (state) => {
      state.isPending = false;
    },
    [getPaymentCardBackupByReference.pending]: (state) => {
      state.isPending = true;
    },
    [getPaymentCardBackupByReference.fulfilled]: (state) => {
      state.isPending = false;
    },
    [getPaymentCardSessionByReference.rejected]: (state) => {
      state.card = null;
      state.isPending = false;
    },
    [getPaymentCardSessionByReference.pending]: (state) => {
      state.isPending = true;
    },
    [getPaymentCardSessionByReference.fulfilled]: (state, action) => {
      state.card = action.payload;
      state.isPending = false;
    },
    [getPaymentCardSessionByIdentityReference.rejected]: (state) => {
      state.card = null;
      state.isPending = false;
    },
    [getPaymentCardSessionByIdentityReference.pending]: (state) => {
      state.isPending = true;
    },
    [getPaymentCardSessionByIdentityReference.fulfilled]: (state, action) => {
      state.card = action.payload;
      state.isPending = false;
    },
    [getPaymentCardSessionByReservation.rejected]: (state) => {
      state.card = null;
      state.isPending = false;
    },
    [getPaymentCardSessionByReservation.pending]: (state) => {
      state.isPending = true;
    },
    [getPaymentCardSessionByReservation.fulfilled]: (state, action) => {
      state.card = action.payload;
      state.isPending = false;
    },
    [createPaymentCardSession.rejected]: (state) => {
      state.isPending = false;
    },
    [createPaymentCardSession.pending]: (state) => {
      state.isPending = true;
    },
    [createPaymentCardSession.fulfilled]: (state, action) => {
      state.card = action.payload;
      state.isPending = false;
    },
    [patchPaymentCardSession.rejected]: (state) => {
      state.isPending = false;
    },
    [patchPaymentCardSession.pending]: (state) => {
      state.isPending = true;
    },
    [patchPaymentCardSession.fulfilled]: (state, action) => {
      state.card = action.payload;
      state.isPending = false;
    },
    [parsePaymentCard.rejected]: (state) => {
      state.isPending = false;
    },
    [parsePaymentCard.pending]: (state) => {
      state.isPending = true;
    },
    [parsePaymentCard.fulfilled]: (state, action) => {
      state.cardList = action.payload;
      state.isPending = false;
    },
    [saveEditedPaymentCard.rejected]: (state) => {
      state.isPending = false;
    },
    [saveEditedPaymentCard.pending]: (state) => {
      state.isPending = true;
    },
    [saveEditedPaymentCard.fulfilled]: (state) => {
      state.isPending = false;
    },
    [getPaymentCardSessionsByStatus.rejected]: (state) => {
      state.isPending = false;
    },
    [getPaymentCardSessionsByStatus.pending]: (state) => {
      state.isPending = true;
    },
    [getPaymentCardSessionsByStatus.fulfilled]: (state, action) => {
      state.cardList = action.payload;
      state.isPending = false;
    },
    [getNameAddressMatchByGuestId.rejected]: (state) => {
      state.address = null;
      state.isPending = false;
    },
    [getNameAddressMatchByGuestId.pending]: (state) => {
      state.isPending = true;
    },
    [getNameAddressMatchByGuestId.fulfilled]: (state, action) => {
      state.address = action.payload;
      state.isPending = false;
    },
    [createNameAddressMatch.rejected]: (state) => {
      state.isPending = false;
    },
    [createNameAddressMatch.pending]: (state) => {
      state.isPending = true;
    },
    [createNameAddressMatch.fulfilled]: (state, action) => {
      state.address = action.payload;
      state.isPending = false;
    },
    [getRiskVerificationByGuestId.rejected]: (state) => {
      state.risk = null;
      state.isPending = false;
    },
    [getRiskVerificationByGuestId.pending]: (state) => {
      state.isPending = true;
    },
    [getRiskVerificationByGuestId.fulfilled]: (state, action) => {
      state.risk = action.payload;
      state.isPending = false;
    },
    [createRiskVerificationSession.rejected]: (state) => {
      state.risk = null;
      state.isPending = false;
    },
    [createRiskVerificationSession.pending]: (state) => {
      state.isPending = true;
    },
    [createRiskVerificationSession.fulfilled]: (state, action) => {
      state.risk = action.payload;
      state.isPending = false;
    },
    [getBackgroundCheckByGuestId.rejected]: (state) => {
      state.background = null;
      state.isPending = false;
    },
    [getBackgroundCheckByGuestId.pending]: (state) => {
      state.isPending = true;
    },
    [getBackgroundCheckByGuestId.fulfilled]: (state, action) => {
      state.background = action.payload;
      state.isPending = false;
    },
    [createBackgroundCheckSession.rejected]: (state) => {
      state.background = null;
      state.isPending = false;
    },
    [createBackgroundCheckSession.pending]: (state) => {
      state.isPending = true;
    },
    [createBackgroundCheckSession.fulfilled]: (state, action) => {
      state.background = action.payload;
      state.isPending = false;
    },
    [addGuest.rejected]: (state) => {
      state.isPending = false;
    },
    [addGuest.pending]: (state) => {
      state.isPending = true;
    },
    [addGuest.fulfilled]: (state, action) => {
      state.guest = action.payload;
      state.isPending = false;
    },
    [updateGuest.rejected]: (state) => {
      state.isPending = false;
    },
    [updateGuest.pending]: (state) => {
      state.isPending = true;
    },
    [updateGuest.fulfilled]: (state, action) => {
      state.guest = action.payload;
      state.isPending = false;
    },
    [addReservation.rejected]: (state) => {
      state.isPending = false;
    },
    [addReservation.pending]: (state) => {
      state.isPending = true;
    },
    [addReservation.fulfilled]: (state, action) => {
      state.reservation = action.payload;
      state.isPending = false;
    },
    [updateReservation.rejected]: (state) => {
      state.isPending = false;
    },
    [updateReservation.pending]: (state) => {
      state.isPending = true;
    },
    [updateReservation.fulfilled]: (state, action) => {
      state.reservation = action.payload;
      state.isPending = false;
    },
    [addReview.rejected]: (state) => {
      state.isPending = false;
    },
    [addReview.pending]: (state) => {
      state.isPending = true;
    },
    [addReview.fulfilled]: (state) => {
      state.isPending = false;
    },
    [updateReview.rejected]: (state) => {
      state.isPending = false;
    },
    [updateReview.pending]: (state) => {
      state.isPending = true;
    },
    [updateReview.fulfilled]: (state, action) => {
      state.review = action.payload;
      state.isPending = false;
    },
  },
});

// Actions

export const {
  resetWidget,
  setCompanyCode,
  setReservationCode,
  setReservationData,
  setDisableWriteReview,
  setDisableIdentityVerification,
  updateCardInList,
  removeCardFromList,
} = widgetSlice.actions;

// Selectors

export const selectCompany = (state) => (state.widget.company);
export const selectCompanyCode = (state) => (state.widget.companyCode);
export const selectReservationCode = (state) => (state.widget.reservationCode);
export const selectGuest = (state) => (state.widget.guest);
export const selectReservation = (state) => (state.widget.reservation);
export const selectReview = (state) => (state.widget.review);
export const selectIdentity = (state) => (state.widget.identity);
export const selectAddress = (state) => (state.widget.identity);
export const selectCard = (state) => (state.widget.card);
export const selectRisk = (state) => (state.widget.risk);
export const selectBackground = (state) => (state.widget.background);
export const selectCardList = (state) => (state.widget.cardList);
export const selectIsPending = (state) => (state.widget.isPending);
export const selectHasGuestAccess = (state) => (state.widget.hasGuestAccess);
export const selectReviewList = (state) => (state.widget.reviewList);
export const selectReviewSummary = (state) => (state.widget.reviewSummary);
export const selectVerificationSummary = (state) => (state.widget.verificationSummary);
export const selectDisableWriteReview = (state) => (state.widget.disableWriteReview);
export const selectDisableIdentityVerification = (state) => (state.widget.disableIdentityVerification);
export const selectFailReason = (state) => (state.widget.identity?.response?.failreason);
export const selectLivenessError = (state) => (state.widget.identity?.response?.liveness?.error);
export const selectLivenessScore = (state) => (state.widget.identity?.response?.liveness?.score);
export const selectLivenessCheck = (state) => (state.widget.identity?.response?.liveness?.passed);
export const selectFirstNameCheck = (state) => (state.widget.identity?.response?.firstnamecheck);
export const selectAgeMinimumCheck = (state) => (state.widget.identity?.response?.ageminimumcheck);
export const selectAuthenticationScore = (state) => (state.widget.identity?.response?.authentication?.score);

export const selectVerificationList = (state) => (state.widget.verificationList.map(
  (verification) => ({
    ...verification,
    id: `${verification.companyCode}${verification.reservationCode}`,
  }),
));

export const selectRecentVerifications = (state) => (state.widget.recentVerifications.map(
  (verification) => ({
    ...verification,
    id: `${verification.companyCode}${verification.reservationCode}`,
  }),
));

export const selectDocumentImages = (state) => (
  (state.widget.identity
    && state.widget.identity.vaultResponse
    && state.widget.identity.vaultResponse.data
  )
    ? state.widget.identity.vaultResponse.data.image
    : []);

export const selectPersonalData = (state) => (
  (state.widget.identity
    && state.widget.identity.response
    && state.widget.identity.response.data
  ));

export const selectNameAddressMatch = (state) => {
  const { guest, address } = state.widget;
  const response = address && address.response;

  if (guest && response) {
    const NAME_MATCH_MAP = {
      Full: 3, First: 2, Last: 2, No: 1,
    };

    return {
      nameVerified: {
        guest: guest && `{${guest.firstName} ${guest.lastName}}`,
        match: response && response.addressNameMatch,
        status: response && NAME_MATCH_MAP[response.addressNameMatch],
      },
      firstNameVerified: {
        guest: guest && guest.firstName,
        match: response && response.addressNameMatch,
        status: (response && ['Full', 'First'].includes(response.addressNameMatch)) ? 3 : 1,
      },
      lastNameVerified: {
        guest: guest && guest.lastName,
        match: response && response.addressNameMatch,
        status: (response && ['Full', 'Last'].includes(response.addressNameMatch)) ? 3 : 1,
      },
      streetVerified: {
        guest: guest && guest.address,
        match: response && response.addressMatch,
        status: (response && response.addressMatch === 'Yes') ? 3 : 1,
      },
      cityVerified: {
        guest: guest && guest.city,
        match: response && response.addressCityNoMatch,
        status: (response && response.addressMatch === 'Yes' && response.addressCityNoMatch === '') ? 3 : 1,
      },
      stateVerified: {
        guest: guest && guest.state,
        match: response && response.addressStateNoMatch,
        status: (response && response.addressMatch === 'Yes' && response.addressStateNoMatch === '') ? 3 : 1,
      },
      postalCodeVerified: {
        guest: guest && guest.postalCode,
        match: response && response.addressZipNoMatch,
        status: (response && response.addressMatch === 'Yes' && response.addressZipNoMatch === '') ? 3 : 1,
      },
      phoneNumberVerified: {
        guest: guest && guest.phoneNumber,
        match: response && (response.phoneNameNoMatch || response.phoneMatch),
        status: (response && response.phoneMatch === 'Yes') ? 3 : 1,
      },
    };
  }

  return {};
};

export const selectNameAddressMatchDemo = (state) => {
  const { guest, address } = state.widget;
  const response = address && address.response;

  if (guest && response) {
    return {
      nameVerified: {
        guest: guest && `{${guest.firstName} ${guest.lastName}}`,
        match: 'Full',
        status: 3,
      },
      firstNameVerified: {
        guest: guest && guest.firstName,
        match: '',
        status: 3,
      },
      lastNameVerified: {
        guest: guest && guest.lastName,
        match: '',
        status: 3,
      },
      streetVerified: {
        guest: guest && guest.address,
        match: '',
        status: 3,
      },
      cityVerified: {
        guest: guest && guest.city,
        match: '',
        status: 3,
      },
      stateVerified: {
        guest: guest && guest.state,
        match: '',
        status: 3,
      },
      postalCodeVerified: {
        guest: guest && guest.postalCode,
        match: '',
        status: 3,
      },
      phoneNumberVerified: {
        guest: guest && guest.phoneNumber,
        match: '',
        status: 3,
      },
    };
  }

  return {};
};

export const selectRiskMatch = (state) => {
  const { guest, risk } = state.widget;
  const response = risk && risk.response;

  if (guest && response) {
    const STATUS_MATCH = {
      0: 'N/A', 1: 'Risky', 2: 'Suspicious', 3: 'Safe',
    };

    let riskStatus = 0;

    if (response.identityRiskScore >= 350) {
      riskStatus = 1;
    } else if (response.identityRiskScore > 250 && response.identityRiskScore < 350) {
      riskStatus = 2;
    } else if (response.identityRiskScore <= 250) {
      riskStatus = 3;
    } else {
      riskStatus = 0;
    }

    return {
      identity: {
        guest: guest && `${guest.firstName} ${guest.lastName}`,
        match: response && response.identityRiskScore,
        valid: STATUS_MATCH[riskStatus],
        status: riskStatus,
        identityRiskScore: response && response.identityRiskScore,
        identityNetworkScore: response && response.identityNetworkScore,
      },
      address: {
        guest: guest && guest.street,
        match: response && response.primaryAddressToName,
        valid: response && response.primaryAddressValidityLevel,
        status: (response && response.primaryAddressToName === 'match') ? 3 : 1,
        firstSeenDays: response && response.primaryAddressFirstSeenDays,
      },
      email: {
        guest: guest && guest.email,
        match: response && response.primaryEmailToName,
        valid: response && response.primaryEmailValid,
        status: (response && response.primaryEmailToName !== 'not-found') ? 3 : 1,
        firstSeenDays: response && response.primaryEmailFirstSeenDays,
        domainCreationDate: response && response.primaryEmailDomainCreationDate,
      },
      phone: {
        guest: guest && guest.phoneNumber,
        match: response && response.primaryPhoneToName,
        valid: response && response.primaryPhoneValid,
        status: (response && response.primaryPhoneToName === 'match') ? 3 : 1,
        phoneCarrier: response && response.primaryPhoneCarrier,
        phoneLineType: response && response.primaryPhoneLineType,
      },
    };
  }

  return {};
};

export const selectBackgroundMatch = (state) => {
  const { guest, background } = state.widget;
  const response = background && background.response;

  if (guest && response) {
    const STATUS_MATCH = {
      F: 1, P: 2, C: 3,
    };

    const STATUS_MESSAGE = {
      F: 'Failed',
      P: 'In Progress',
      C: 'Passed',
    };

    return {
      summary: {
        reference: background.reference,
        status: STATUS_MATCH[background.status],
        message: STATUS_MESSAGE[background.status],
      },
      results: response.searchResults && response.searchResults.record,
    };
  }

  return {};
};

// Reducer

export default widgetSlice.reducer;
